import { Helmet } from "react-helmet";
import PortfolioUploadSection from "./PortfolioUploadSection";
import DashboardTopbar from "components/DashboardTopbar";
import DashboardMenuBar from "components/DashboardMenuBar";
import "styles/dashboard.css";

export default function PortfolioUpload() {
  return (
    <>
      <Helmet>
        <title>Upload Your Portfolio - Begin Tracking</title>
        <meta
          name="description"
          content="Easily upload your portfolio and start managing your assets. Drag & drop functionality makes it simple to keep your investments in check."
        />
      </Helmet>
      <div className="trg-shell">
        <DashboardTopbar />
        <DashboardMenuBar activePage="Portfolio Upload" />
        <main style={{ flex: 1, padding: "36px 40px", overflowY: "auto", overflowX: "hidden", background: "#181719", minHeight: 0 }}>
          <PortfolioUploadSection />
        </main>
      </div>
    </>
  );
}
